/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_Error_GenericInputs */



/**
* | output |
* | --- |
* | "This code is invalid or has expired. Start again from your app." |
*
* @param {Auth_Device_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_error_generic = /** @type {((inputs?: Auth_Device_Error_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_Error_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Code ist ungültig oder abgelaufen. Starte den Vorgang in deiner App erneut.")
	return /** @type {LocalizedString} */ ("This code is invalid or has expired. Start again from your app.")
});